/**
 * Abstract our storage calls.
 * Uses sessionStorage so cached tokens (SAS etc.) are cleared on tab close.
 */

async function setItem(item: string, value: string) {
  sessionStorage.setItem(item, value);
}

async function getItem(item: string) {
  return sessionStorage.getItem(item);
}

async function removeItem(item: string) {
  sessionStorage.removeItem(item);
}

const storageService = {
  setItem,
  getItem,
  removeItem,
};

export default storageService;
